export default __webpack_public_path__ + "static/media/pay_now_qr_code.20d91a7a.jpeg";